
export const environment = {
  production: true,
  commonPaymentApiBasePath: 'https://paybyphone.cinchhs.com/commonPayment/',
  ivrCallTransfer: 'https://apis.cinchhomeservices.com/paymentsvc/api/callmonitor/',
  originalPaymentUIDomain: 'https://payment.cinchhs.com/'
};
